import { create } from "zustand";

interface DisplayNameState {
  displayName: string;
  setDisplayName: (name: string) => void;
}

export const useDisplayNameStore = create<DisplayNameState>((set) => ({
  displayName: "",
  setDisplayName: (name) => set({ displayName: name }),
}));
